const CasLoginUrl = 'https://sso.corp.kuaishou.com/cas/login';

/**
 *
 * @description 要求后端实现支持 /contextpath/api/login?ticket=${ST}&redirect_url=${回调地址} 接口
 * @param service 登录成功回调回调后端地址
 * @param redirect_url 后端权限更新后回调地址
 */
export function login(
  service = `${location.origin.replace('local.', '')}/api/mario/sso-login`,
  redirectUrl: string = location.href,
) {
  const loginUrl = `${CasLoginUrl}?service=${encodeURIComponent(
    `${service}?redirect_url=${encodeURIComponent(redirectUrl)}`,
  )}`;
  location.href = loginUrl;
}
